/* eslint-disable */
import { useMemo, useState } from 'react';
import { ReactComponent as ExportIcon } from '../../../../../assets/icons/export_icon_gray.svg';
import { useDispatch, useSelector } from 'react-redux';
import { checkPermission } from '../../../../../helpers/checkPermissions';
import permissions from '../../../../../config/permissions';
import { REQUEST_STATUS } from '../../../../../redux_store';
import { useMutation } from 'react-fetching-library';
import showServerError from '../../../../../helpers/showError';
import { makeStyles } from '@material-ui/core';
import MenuItemWithDialog
  from '../../../../Shared/Table/widgets/TopBar/MenuItem/MenuItemWithDialog';
import RoundedButton from '../../../../Shared/RoundedButton';
import { getEndpoint } from '../../../../../helpers/endpoint';
import { useParams } from 'react-router-dom';

const useStyles = makeStyles((theme) => ({
  selectorMenu: {
    padding: 3,
    fontWeight: 400,
    maxWidth: 220,
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
    overflow: 'hidden',
    fontSize: '1rem',
    boxSizing: 'border-box',
    lineHeight: 1.5,
    letterSpacing: '0.00938em',
  },
  icon: {
    transform: 'rotate( -180deg )',
    width: 20,
    height: 20,
  },
  driver: {
    borderTop: `1px solid ${theme.palette.text.secondary}`,
    opacity: 0.2,
  },
  description: {
    maxWidth: 200,
    paddingBottom: 12,
  },
  option: {
    justifyContent: 'flex-start',
  },
}));

const DownloadTableFile = ({
                             fileName,
                             endpoint,
                             tableKey,
                             tableFilter,
                             tableSort,
                             totalCount,
                           }) => {
  const { en } = useSelector((state) => state.i18n);
  const { tables: tTables, btn: tBtn, notifications } = en;
  const [isOpenDialog, setOpenDialog] = useState(false);
  const [downloadingZIPStatus, setDownloadingZIPStatus] = useState(REQUEST_STATUS.idle);
  const classes = useStyles();
  const dispatch = useDispatch();
  const { accountUuid: paramAccountUuid } = useParams();
  const {
    user,
    metadata: { currentAccount, currentAccountPermissions },
  } = useSelector((state) => state.user);
  const {
    settings,
  } = useSelector((state) => state.table);

  const hasLoadCSVPermission = useMemo(
    () => checkPermission(
      currentAccountPermissions,
      permissions.ADMIN_PATIENT_IMPORT,
    ),
    [currentAccountPermissions],
  );

  const handleCloseDialog = () => {
    setOpenDialog(false);
  };

  const getResourcesCSV = (fields) => ({
    method: 'GET',
    endpoint: getEndpoint(`/accounts/${
      paramAccountUuid || currentAccount.uuid
    }${endpoint}`, { fields }, tableSort, tableFilter),
    responseType: 'blob',
    headers: {
      'Content-Type': 'text/csv',
    },
  });

  const { mutate: getCSV } = useMutation(getResourcesCSV);

  const downloadedFile = async () => {
    setDownloadingZIPStatus(REQUEST_STATUS.loading);
    const FIELDS_FOR_CSV = Object.keys(settings[tableKey].columnVisibility)
      .filter(key => settings[tableKey].columnVisibility[key])
      .filter(key => ![
      'mrt-row-actions',
      'mrt-row-select',
    ].includes(key));
    const { payload, error, status } = await getCSV(FIELDS_FOR_CSV.join());
    if (error) {
      setDownloadingZIPStatus(REQUEST_STATUS.failed);
      const options = payload && {
        correlationUUID: payload.correlationUUID,
        userUUID: user.uuid,
      };
      switch (status) {
        case 401: {
          showServerError(dispatch, notifications.notPermissionForDownloadingFile);
          break;
        }
        default: {
          showServerError(dispatch, '', options);
          break;
        }
      }
    } else if (payload && payload.size > 0) {
      setDownloadingZIPStatus(REQUEST_STATUS.succeeded);
      const url = window.URL.createObjectURL(new Blob([payload]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', fileName);
      document.body.appendChild(link);
      link.click();
      handleCloseDialog();
    }
    setTimeout(() => {
      setDownloadingZIPStatus(REQUEST_STATUS.idle);
    }, 2000);
  };

  return <>
    {hasLoadCSVPermission && <>
      <MenuItemWithDialog
        icon={<ExportIcon className={classes.icon} />}
        label={tTables.downloadCSVFile}
        onClick={() => setOpenDialog(true)}
        isLoading={downloadingZIPStatus === REQUEST_STATUS.loading}
        isSuccess={downloadingZIPStatus === REQUEST_STATUS.succeeded}
        isFailed={downloadingZIPStatus === REQUEST_STATUS.failed}
        isDisabled={!totalCount}

        dialogTitle={tTables.downloadFileByFilters}
        dialogSubtitle={tTables.downloadFileFilteredData}
        dialogIsOpen={isOpenDialog}
        dialogHandleClose={handleCloseDialog}
        dialogOptions={[
          {
            label: tTables.numbersOfRows,
            value: totalCount,
          },
        ]}
        dialogActions={<RoundedButton
          onClick={downloadedFile}
          isLoading={downloadingZIPStatus === REQUEST_STATUS.loading}
          disabled={downloadingZIPStatus === REQUEST_STATUS.loading}
          variant='contained'
          color='primary'
          size='small'
          className={classes.btn}
          LoadingWrapperProps={{
            LoaderProps: {
              disableShrink: true,
            },
          }}
        >
          {tBtn.downloadCSV}
        </RoundedButton>}
      />
    </>}
  </>;
};

export default DownloadTableFile;
